import Vue from 'vue'

import {
    forEach as _forEach,
    orderBy as _orderBy,
} from 'lodash'

import OrderModel from '@/models/OrderModel'

import carService from '@/services/car.service'

// -----------------------------------------------------------------------------

const state = {
    isLoading: false,
    isCanceling: false,
    orders: {},
}

const getters = {
    getOrders: state => {
        return _orderBy(state.orders, ['date'], ['desc'])
    },

    getOrder: state => orderId => {
        return state.orders[orderId] || null
    },
}

const mutations = {
    setLoading(state, isLoading) {
        state.isLoading = !!isLoading
    },

    setCanceling(state, isCanceling) {
        state.isCanceling = !!isCanceling
    },

    setOrders(state, payload) {
        state.orders = {}

        _forEach(payload, item => {
            const order = new OrderModel(item)

            Vue.set(state.orders, order.id, order)
        })
    },

    setOrder(state, payload) {
        const order = new OrderModel(payload)

        Vue.set(state.orders, order.id, order)
    },
}

const actions = {
    async fetch({ commit }) {
        commit('setLoading', true)

        try {
            const response = await carService.getCurrentOrders()

            commit('setOrders', response?.items || [])
            commit('setLoading', false)
        } catch (error) {
            commit('setLoading', false)
            return Promise.reject(error)
        }
    },

    async cancelOrder({ commit }, params) {
        commit('setCanceling', true)

        try {
            await carService.cancelOrder(params)

            commit('setCanceling', false)
        } catch (error) {
            commit('setCanceling', false)
            return Promise.reject(error)
        }
    },
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
}
